<template>
  <div class="permission-child">
    <div class="permission-item-wrapper">
      <div class="line-1">
        <div class="left">
          <div>{{ root[labelKey] }}</div>
        </div>
        <van-icon
          v-if="root.children && root.children.length"
          @click.stop="$emit('toggle', root[idKey])"
          :name="toggleList.includes(root[idKey]) ? 'arrow-up' : 'arrow-down'"
          class="toggle-icon"
        />
      </div>
    </div>
    <div
      class="children-wrapper"
      :class="{ 'no-indent': level >= 4 }"
      v-if="root.children && root.children.length"
      v-show="toggleList.includes(root[idKey])"
    >
      <permission-child
        v-for="item in root.children"
        :key="item[idKey]"
        :level="level + 1"
        :root="item"
        :toggleList="toggleList"
        @toggle="id => $emit('toggle', id)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'permission-child',
  props: {
    root: {
      type: Object,
    },
    level: {
      type: Number,
      default: 1,
    },
    toggleList: {
      type: Array,
      default: () => [],
    },
    idKey: {
      type: String,
      default: 'id',
    },
    labelKey: {
      type: String,
      default: 'add_label',
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.permission-child {
  width: 100%;
  .permission-item-wrapper {
    width: 100%;
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    border-bottom: 1px solid var(--g3);
    .line-1 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g8);
        display: flex;
        align-items: center;
      }
      .toggle-icon {
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        color: var(--g6);
      }
    }
    .line-2 {
      margin-left: calc(var(--gap) * 32);
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      color: var(--g6);
    }
  }
  .children-wrapper {
    padding-left: calc(var(--gap) * 32);
    &.no-indent {
      padding-left: 0;
    }
  }
}
</style>